module.exports = __webpack_public_path__ + "media/packs/images/notification/attachment-read-41aaf6af94c2c1a0dd71edf61f3d15d1.svg";